import ArticleLayout from '@/components/base/ArticleLayout';
import { allArticles } from '@/mocks/seoArticles';

export default function ConfrontoAgentPage() {
  return <ArticleLayout data={allArticles['confronto-agent']} />;
}